import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import FullWidthSection from '../components/FullWidthSection'
import Tabs from '../components/Tabs'
import {setConfig} from '../actions'
import spacing from 'material-ui/styles/spacing'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

import {initLogbook} from '../actions'

let tabList = [
  { route: '/rebolt', label:'Rebolt日誌'},
  { route: '/rebolt-report', label:'Rebolt報告'},
  { route: '/test', label:'測試日誌'},
  { route: '/test-report', label:'測試報告'},
]


class LogbookPage extends Component {
  static childContextTypes = {
    muiTheme: PropTypes.object,
  }
  state = {muiTheme:getMuiTheme()}
  getChildContext() {
    return {
      muiTheme: this.state.muiTheme,
    }
  }
  componentDidMount() {
    this.props.dispatch(initLogbook())
  }

  render() {
    return (
        <Tabs tabList={tabList} {...this.props}/>
    )
  }
}


function mapStateToProps(state,props) {
  let { me } = state
  return {
    me
  }
}

export default connect(mapStateToProps)(LogbookPage)



/** WEBPACK FOOTER **
 ** ./src/app/containers/LogbookPage.js
 **/